import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Subheader from "../../component/Subheader";

export default function Faqs() {
  const [active, setActive] = useState("0");

  const subheadData = {
    heading: 'Frequently Asked Questions',
    breadcrumb: [
      {
        slug: "",
        name: "Frequently Asked Questions",
      },
    ]
  }

  return (
    <>
      <Subheader subheadData={subheadData} />

      <section className="termscondition-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-4">
              <div className="quick-link-area">
                <h2 className="faqquickbox-text heading">Quick Links</h2>
                <ul>
                  <li> <NavLink to="/terms" end>Terms and Conditions</NavLink></li>

                  <li><NavLink to="/terms" end>Privacy Policy</NavLink> </li>

                  <li><NavLink to="/terms"> Refund & Cancellation Policy</NavLink></li>

                  <li><NavLink to="/faqs" end>FAQ’s</NavLink> </li>

                  <li><NavLink to="/terms" end>Child Policy</NavLink></li>

                  <li><NavLink to="/terms" end>Pets Policy</NavLink>  </li>
                </ul>
              </div>
            </div>

            <div className='col-lg-9 col-md-8'>
              <div className="termscondition-text-main">
                <span>FAQ’s</span>
                <h3 className="heading">General Questions </h3>

                <Accordion activeKey={active} onSelect={(e) => setActive(e)}>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header as="span">
                      What types of accommodations are available at De Coração?
                      <div className="right-icon">
                        {active === "0" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Across our branches, we offer everything from cozy Standard and Deluxe rooms to private independent cottages, some featuring personal Jacuzzis, bathtubs, or pet-friendly layouts.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header as="span">
                      What dining experiences can guests enjoy at the resort?
                      <div className="right-icon">
                        {active === "1" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Guests can indulge at <b> Ice and Spice </b>, our signature restaurant featuring live grills, world cuisine, and regional favorites served in both elegant indoor and breezy al-fresco settings.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header as="span">
                      Does De Coracao offer spa and wellness services?
                      <div className="right-icon">
                        {active === "2" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes, our  <b> Rejuvenation Retreat </b> offers a bespoke menu of traditional Ayurvedic rituals, signature massages, and holistic therapies designed to restore balance to your body and mind.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header as="span">
                      Is De Coração suitable for weddings and special events?
                      <div className="right-icon">
                        {active === "3" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Absolutely. We specialize in "storybook" weddings and celebrations, providing dedicated specialists to manage everything from intimate garden ceremonies to grand forest or riverside festivities.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header as="span">
                      Are there activities available for guests during their stay?
                      <div className="right-icon">
                        {active === "4" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      We offer curated outdoor experiences ranging from jungle safaris and riverside rafting to peaceful forest trails and local cultural tours across our three unique destinations.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header as="span">
                      Is De Coração family-friendly?
                      <div className="right-icon">
                        {active === "5" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes, we provide spacious family cottages and multi-bed rooms designed for togetherness, along with plenty of open green spaces and activities that guests of all ages will enjoy.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="6">
                    <Accordion.Header as="span">
                      Does the resort offer spaces for corporate meetings or retreats?
                      <div className="right-icon">
                        {active === "6" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      We feature modern MICE facilities like the <b> Waves Conference Hall</b>, equipped with high-end AV systems and dedicated support for productive executive retreats and large conferences.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="7">
                    <Accordion.Header as="span">
                      What makes De Coração a unique resort experience?
                      <div className="right-icon">
                        {active === "7" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Our "From the Heart" philosophy combines genuine hospitality with deep respect for our locations, ensuring every stay feels like a personalized recovery from the rush of daily life.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="8">
                    <Accordion.Header as="span">
                      Is the resort surrounded by natural landscapes?
                      <div className="right-icon">
                        {active === "8" ? "-" : "+"}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      Yes, each branch is uniquely positioned to immerse you in nature, whether it is the coastal palms of Goa, the dense forests of Corbett, or the riverside calm of Rishikesh.
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </div>
            </div>
          </div>

        </div>

      </section>


    </>
  )
}
